import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { CalendarClock, Phone, CheckCircle2, X } from "lucide-react";

const STATUS_CLS = {
  scheduled: "bg-sky-100 text-sky-800",
  completed: "bg-emerald-100 text-emerald-800",
  cancelled: "bg-slate-200 text-slate-600",
};

export default function OwnerVisits() {
  const [visits, setVisits] = useState([]);
  const load = () => api.get("/visits").then((r) => setVisits(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (v, status) => {
    try {
      await api.patch(`/visits/${v.id}/status`, { status });
      toast.success(`Visit marked ${status}`);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Update failed");
    }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-6" data-testid="owner-visits-section">
      <h2 className="font-display font-bold text-xl flex items-center gap-2">
        <CalendarClock size={18} className="text-orange-800" /> Visit requests
      </h2>
      <p className="text-xs text-slate-500 mt-1">Students who scheduled a free in-person visit to your hostels.</p>
      <div className="mt-4 space-y-3">
        {visits.length === 0 && <div className="text-sm text-slate-500">No visit requests yet.</div>}
        {visits.slice(0, 12).map((v) => (
          <div key={v.id} data-testid={`owner-visit-${v.id}`} className="border border-slate-200 rounded-xl p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="font-semibold text-sm truncate">{v.name}</div>
                <div className="text-xs text-slate-500 flex items-center gap-1 mt-0.5"><Phone size={10} /> {v.phone}</div>
                <div className="text-xs text-slate-600 mt-1">{v.hostel_name} · <b>{v.visit_date}</b> at <b>{v.visit_time}</b></div>
              </div>
              <span className={`inline-block text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded-full flex-shrink-0 ${STATUS_CLS[v.status] || "bg-slate-100 text-slate-700"}`}>{v.status}</span>
            </div>
            {v.status === "scheduled" && (
              <div className="mt-3 flex gap-2">
                <button data-testid={`owner-visit-complete-${v.id}`} onClick={() => setStatus(v, "completed")} className="inline-flex items-center gap-1 text-[11px] font-bold rounded-full px-3 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white">
                  <CheckCircle2 size={12} /> Mark completed
                </button>
                <button data-testid={`owner-visit-cancel-${v.id}`} onClick={() => setStatus(v, "cancelled")} className="inline-flex items-center gap-1 text-[11px] font-bold rounded-full px-3 py-1.5 border border-rose-300 text-rose-700 hover:bg-rose-50">
                  <X size={12} /> Cancel
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
